import React, { useEffect, useState } from "react";
import "./CreateGroupModal.css";
import { Rnd } from "react-rnd";
import "./CreateGroupModal.css";

const IframeModal = ({ show, onClose, url, isPlaybookLink }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [size, setSize] = useState({
    width: windowWidth * 0.42,
    height: windowHeight - 120,
  });
  const [position, setPosition] = useState({
    x: windowWidth * 0.345,
    y: 0,
  });

  // Function to handle the resize event
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);
  };

  // Add event listener for window resize
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (!show) return null;

  return (
    <Rnd
      className={isPlaybookLink ? "full-screen-view" : ""}
      disableDragging={isPlaybookLink}
      enableResizing={!isPlaybookLink}
      position={
        isPlaybookLink ? { x: 0, y: 0 } : { x: position.x, y: position.y }
      }
      default={{
        x: 0,
        y: 0,
        width: isPlaybookLink ? "100%" : size.width,
        height: isPlaybookLink ? "100%" : size.height,
      }}
      onDragStop={(e, d) => {
        if (!isPlaybookLink) setPosition({ x: d.x, y: d.y });
      }}
      onResize={(e, direction, ref, delta, position) => {
        setSize({
          width: ref.offsetWidth,
          height: ref.offsetHeight,
        });
        if (!isPlaybookLink) setPosition(position);
      }}
      style={{
        ...(isPlaybookLink
          ? {}
          : {
              display: show ? "flex" : "none",
              flexDirection: "column",
              background: "white",
              boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
              border: "1px solid #ddd",
              zIndex: 1000,
              position: "fixed",
            }),
      }}
      bounds="window"
      width={isPlaybookLink ? "100%" : 660}
      minWidth={isPlaybookLink ? "100%" : 450}
    >
      <div className="iframe-modal-overlay" style={modalOverlayStyles}>
        <div className="iframe-modal-content" style={modalContentStyles}>
          {/* Close button */}
          <button
            className="close-btn"
            onClick={onClose}
            style={closeButtonStyles}
          >
            &times;
          </button>
          {/* Iframe */}
          <iframe
            src={url}
            width="100%"
            height="100%"
            title="Document Viewer"
            style={iframeStyles}
          ></iframe>
        </div>
      </div>
    </Rnd>
  );
};

// Modal overlay styles
const modalOverlayStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

// Modal content styles with larger dimensions
const modalContentStyles = {
  backgroundColor: "#fff",
  paddingTop: "30px",
  paddingBottom: "20px",
  paddingLeft: "20px",
  paddingRight: "20px",
  borderRadius: "8px",
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "800px",
  position: "relative",
  overflow: "hidden", // Prevent overflow
};

// Close button styles
const closeButtonStyles = {
  position: "absolute",
  top: "-9px",
  right: "7px",
  backgroundColor: "transparent",
  border: "none",
  fontSize: "2rem",
  cursor: "pointer !important",
  color: "#333",
};

// Iframe styles to ensure it stays within the modal
const iframeStyles = {
  width: "100%",
  height: "100%",
  objectFit: "contain", // Scale the content inside the iframe proportionally
};

export default IframeModal;
